<template>
<div class="chapter">
<div class="inner_page">
<h1>Copyright</h1>
<p class="sectiontop" style="text-align: center;">Diversion Books<br/>
  A Division of Diversion Publishing Corp.<br/>
  443 Park Avenue South, Suite 1008<br/>
  New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">Copyright © 1995 by Jane Heller<br/>
  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="sectiontop" style="text-align: center;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">First Diversion Books edition March 2016<br/>
  ISBN: 978-1-68230-357-3</p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<h1 class="sigil_not_in_toc">Also by Jane Heller</h1>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample"><b>Fiction</b><br/>
<i>Best Enemies<br/>
  Crystal Clear<br/>
  Female Intelligence<br/>
  Infernal Affairs<br/>
  Lucky Stars<br/>
  Name Dropping<br/>
  Clean Sweep<br/>
  Sis Boom Bah<br/>
  Princess Charming<br/>
  The Secret Ingredient<br/>
  An Ex to Grind<br/>
  Some Nerve</i></span></p>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample"><b>Non-Fiction</b><br/>
<i>Confessions of a She-Fan: The Course of True Love with the New York Yankees<br/>
  You’d Better Not Die or I’ll Kill You: A Caregiver’s Survival Guide to Keeping You in Good Health and Good Spirits</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?77041e5d